import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import RootHome from '@/views/RootHome.vue'
import SearchResults from '@/views/SearchResults.vue'
import CatalogProducts from '@/views/CatalogProducts.vue'
import CatalogsViews from '@/views/CatalogsViews.vue'
import CatalogsViewsContainer from '@/views/CatalogsViewsContainer.vue'
import ModelDetail from '@/views/ModelDetail.vue'
import ShoppingCart from '@/views/ShoppingCart.vue'
import PageDetails from '@/views/PageDetails.vue'
import ProfileDetails from '@/views/ProfileDetails.vue'
import DatiUtente from "@/components/profile/DatiUtente.vue";
import IndirizziSpedizione from "@/components/profile/IndirizziSpedizione.vue";
import DatiFatturazione from "@/components/profile/DatiFatturazione.vue";
import StoricoOrdini from "@/components/profile/StoricoOrdini.vue";
import CambiaPassword from "@/components/profile/CambiaPassword.vue";
import ModificaDatiAnagrafici from "@/components/profile/ModificaDatiAnagrafici.vue";
import RecuperoPassword from "@/views/RecuperoPassword.vue";
import Scadenzario from "@/components/profile/Scadenzario.vue";
import Backorder from "@/views/Backorder.vue";
import OrderForm from "@/views/OrderForm.vue";
import DocumentiView from "@/views/DocumentiView.vue";
import SchedaFatturaView from "@/views/SchedaFatturaView.vue";

import Home from '@/views/Home.vue'
import store from '@/store'

const routes = [
	{
		path: '/',
		name: 'Login',
		component: Login
	},
	{
		path: '/password-recovery',
		name: 'PasswordRecovery',
		component: RecuperoPassword
	},
	{
		path: '/home',
		name: 'HomeCont',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		//component: () => import(/* webpackChunkName: "home" */ '../views/RootHome.vue'),
		component: RootHome,
		beforeEnter(to, from, next){     
			if(store.getters.getAuthenticated){
				next();
			}
			else{
					next('/');
				}
		},
		children:[
			{
				path: '',
				name: 'Home',
				component: Home
			},
			{
				path: "search-results",
				name: "SearchResults",
				component: SearchResults
			},
			{
				path: "backorder",
				name: "Backorder",
				component: Backorder
			},
			{
				path: "catalogs",
				name: "Catalogs",
				component: CatalogsViewsContainer,
				children: [
					{
						path: '',
						name: 'CatalogsViews',
						component: CatalogsViews,
						meta: {
							breadCrumbs: [
								{
									to: '/',
									text: 'Home' 
								},
								{
									to: '',
									text: 'Catalogs'
								}
							]}
						},
					{
					path: ":idCatalog",
					name: "CatalogProducts",
					component: CatalogProducts,
					meta: {
						breadCrumbs: [{
								to: '/',          
								text: 'Home' 
							},
							{
								to: '/home/catalogs',
								text: 'Catalogs'
							},
							{
								to: '',
								text: 'Catalog'
							}
						]}       
					}
				]
			},
			{
				path: "model-detail/:idCatalog/:idCategory/:idModel",
				name: "ModelDetail",
				component: ModelDetail,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
			{
				path:"shopping-cart",
				name: "ShoppingCart",
				component: ShoppingCart,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
			{
				path: "pages/:permalink",
				name: "Pages",
				component: PageDetails,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
			{
				path: "profile",
				name: "Profile",
				component: ProfileDetails,
				meta: {
					breadCrumbs: [
						{
							to: '/',
							text: 'Home' 
						},
						{
							to: '',
							text: 'Profile'
						}         
					]
				},
				children: [
					{
						path: 'user-details',
						name: 'UserDetails',
						component: DatiUtente
					},
					{
						path: 'payment-deadlines',
						name: 'PaymentDeadlines',
						component: Scadenzario
					},
					{
						path: 'destination-address',
						name: 'DestinationAddresses',
						component: IndirizziSpedizione
					},
					{
						path: 'billing-addresses',
						name: 'BillingAddresses',
						component: DatiFatturazione
					},
					{
						path: 'order-history',
						name: 'OrderHistory',
						component: StoricoOrdini
					},
					{
						path: 'change-password',
						name: 'ChangePassword',
						component: CambiaPassword
					},
					{
						path: 'change-personal-data',
						name: 'ChangePersonalData',
						component: ModificaDatiAnagrafici
					}
				]
			},
			{
				path: "orderForm",
				name: "orderForm",
				component: OrderForm,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},{
				path: "documents",
				name: "Documenti",
				component: DocumentiView,
				meta:{
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
			{
				path: "documents/:idDoc",
				name: "SchedaFattura",
				component: SchedaFatturaView,
				meta:{
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			}
		]
	}
]

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { left: 0, top: 0 }
	}
})

export default router
